// Single source of truth for E-course meditation tracks.
// These mirror the Power Planning Practice App library and are mapped into
// the course UI per the user's spec (Option A):
//   - START_HERE_TRACK shown on the course homepage at the top
//   - SET_POINT_TRACKS shown inside Chapter 3 ("Emotion of the End Result")
//   - BONUS_TRACKS shown on the course homepage as "Bonus Practices"

const ASSET = (slug) =>
  `https://customer-assets.emergentagent.com/job_e5aeb861-4698-4c3f-a54b-4b0b2b4402c1/artifacts/${slug}`;

export const START_HERE_TRACK = {
  id: 'start-here-daily',
  title: 'Daily Power Planning Practice Meditation',
  audio_url: ASSET('lziyx6m7_Daily%20Power%20Planning%20Practice%20Meditation%20with%20evening%20check%20in-%20062026.mp3'),
};

export const SET_POINT_TRACKS = [
  { id: 'sp-1-magnetic-alignment',  title: 'Create Magnetic Alignment with your true goal',
    audio_url: ASSET('950u87eg_Magnetic%20Alignment%20Formula%20062026.mp3') },
  { id: 'sp-2-flip-beliefs',         title: 'Flip Negative Beliefs at their root',
    audio_url: ASSET('1nj4fp6k_Negative%20Belief%20Flip%20062026.mp3') },
  { id: 'sp-3-inner-power',          title: 'Activate your Inner Power',
    audio_url: ASSET('6jz8hlj2_Inner%20Power%20Meditation%20062026.mp3') },
  { id: 'sp-4-quantum-jumping',      title: 'Enable Quantum Jumping to new realities',
    audio_url: ASSET('ro9rkvbr_Quantum%20Jumping%20062026.mp3') },
  { id: 'sp-5-dissolve-conflicted',  title: 'Dissolve Conflicted Parts within you',
    audio_url: ASSET('lz99qocn_Dossolve%20Conflicted%20Parts%20062026.mp3') },
  { id: 'sp-6-financial-abundance',  title: 'Open you to Total Financial Abundance',
    audio_url: ASSET('iun8fha3_Total%20Abundance%20Meditation%20062026.mp3') },
  { id: 'sp-7-authentic-confidence', title: 'Build Authentic Confidence',
    audio_url: ASSET('n45rg89p_Authentic%20Confidence%20Meditation%20062026.mp3') },
  { id: 'sp-8-internal-fire',        title: 'Ignite your Internal Fire',
    audio_url: ASSET('4vwylo67_Internal%20Fire%20Meditation%20062026.mp3') },
];

export const BONUS_TRACKS = [
  { id: 'bonus-1-wisdom-process',     title: 'The Wisdom Process Meditation',
    audio_url: ASSET('zbt3nrfq_Wisdom%20Meditation.mp3') },
  { id: 'bonus-2-double-bubble',      title: 'The Double Bubble Meditation',
    audio_url: ASSET('o0dljupv_Double%20Bubble%20with%20Recode%20~%2011%2F6%2F2025.mp3') },
  { id: 'bonus-3-parts-integration',  title: 'Parts Integration Meditation',
    audio_url: ASSET('7qzj7wxk_Parts%20Integration%20Meditation%20with%20Recode~%2012-20-25.mp3') },
  { id: 'bonus-4-emotional-flood',    title: 'Emotional Flood Meditation',
    audio_url: ASSET('3panxkww_Emotional%20Flood%20Meditation%20062026.mp3') },
];
